module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.params.title || 'Välj'))]), _vm._v(" "), _c('div', {
    staticClass: "multiselect-container"
  }, [_vm._l((_vm.params.options), function(option) {
    return _c('div', {
      key: option.id,
      staticClass: "option-row"
    }, [_c('Checkbox', {
      attrs: {
        "label": option.name,
        "label-position": "right",
        "value": true,
        "valuebinder": _vm.localSelection[option.id],
        "type": "checkbox",
        "special-class": "wishes"
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(_vm.localSelection, option.id, $event)
        }
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "2rem"
    }
  }, [_c('button', {
    staticClass: "small",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s('Spara'))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25b28986"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/AdminMultiSelectModal.vue
// module id = 923
// module chunks = 0